import { render } from "./SubTopNavBar.vue?vue&type=template&id=8cf34696&scoped=true"
import script from "./SubTopNavBar.vue?vue&type=script&lang=js"
export * from "./SubTopNavBar.vue?vue&type=script&lang=js"

import "./SubTopNavBar.vue?vue&type=style&index=0&id=8cf34696&lang=scss&scoped=true"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf34696"]])

export default __exports__